import DynamicMarketLocations from "../components/dynamicMarketLocations";
import { openSecondModal } from "../utils/other";
import getNearestPlaces from "../components/geolocation";
$(function () {
  const DynamicMarketLocationsInstance = new DynamicMarketLocations(
    ".js-markets-dropdown"
  );
  DynamicMarketLocationsInstance.init();

  getNearestPlaces().then((places) => {
    if ($(".js-markets-dropdown").length > 0) {
      const { id } = places.markets[0];
      $(".js-markets-dropdown").find(`li[data-value=${id}]`).trigger("click");
    }
  });
});

// handle additional form modal
$(document).on("click", ".js-open-book-tour-modal", function (e) {
  const $event = $(e.target);
  openSecondModal("modal-book-a-tour");

  const locationName = $event.data("location");
  const $locationSelect = $(".js-modal-book-a-tour").find(
    "[name='location_id']"
  );
  const $locationSelectOptions = $locationSelect.find("option");

  $locationSelectOptions.each((option) => $(option).removeAttr("selected"));

  $locationSelectOptions
    .filter(function () {
      return $(this).data("location_name") === locationName;
    })
    .prop("selected", true);
});
